import Vue from 'vue';
import {axiosGet, urlGenerator, externalApiCall} from '../../../app/Helpers/AxiosHelper';
import DateFunction from "../../../core/helpers/date/DateFunction";
import * as actions from '../../../app/Config/ApiUrl';
import * as dateTimeFunc from '../../../app/Helpers/DateTimeHelper';
import axios from 'axios';
import {getWebUrlFromDeepLink} from "../../../app/Helpers/Helpers";

export default {
    state: {
        loggedInUser: {},
        profile_picture: '',
        notificationList: [],
        socialLinks: [],
        users: [],
    },

    getters: {
        notificationList: state => state.notificationList,
        getUsers: state => state.users,
    },

    mutations: {
        SET_USERS(state, data) {
            state.users = data
        },
        GET_USER(state, obj) {
            const {rootState, user} = obj;
            state.loggedInUser = user;

            if (user.profile) {
                state.loggedInUser.date_of_birth = user.profile.date_of_birth ? new Date(user.profile.date_of_birth) : null;
                state.loggedInUser.gender = user.profile?.gender;
                state.loggedInUser.contact = user.profile?.contact;
                state.loggedInUser.address = user.profile?.address;
            }

            state.loggedInUser.created_at = user.created_at ? DateFunction.getDateFormat(user.created_at, rootState.settings.dateFormat) : '';
            state.loggedInUser.role = user.roles && user.roles.length ? user.roles[0].name : '';
            state.profile_picture = user.profile_picture?.full_url ? user.profile_picture.full_url : urlGenerator('/images/avatar-demo.jpg');
            state.loggedInUser.img = user.profile_picture?.full_url ? user.profile_picture.full_url : urlGenerator('/images/avatar-demo.jpg');
            state.socialLinks = user?.social_links ? user.social_links.filter((item, index) => {
                item.link = item.pivot?.link;
                item.edit = false;
                return item;
            }) : [];
        },
        GET_NOTIFICATIONS(state, obj) {
            const {rootState, notifications, total_unread} = obj,
                timeFormat = rootState.settings.timeFormat,
                dateFormat = rootState.settings.dateFormat;

            state.notificationList = notifications.map(item => {
                const {id, title, body, deep_link, created_at, read_at} = item;

                return {
                    img: urlGenerator('/images/icon.png'),
                    id: id,
                    name: Vue.prototype.$t('system_notification') || 'System Notification',
                    title: title || '',
                    description: body || '',
                    time: dateTimeFunc.getTimeFromDateTime(created_at, timeFormat),
                    date: dateTimeFunc.getDateFromNow(created_at, dateFormat),
                    status: read_at == null ? Vue.prototype.$t('new') : Vue.prototype.$t('old'),
                    url: deep_link ? urlGenerator(getWebUrlFromDeepLink(deep_link)) : '#'
                }
            });
            state.notificationList['total_unread'] = total_unread || notifications.filter(notification => notification.read_at == null).length;
        },
    },

    actions: {
        getUser({commit, rootState}) {
            // Try external API endpoint first
            externalApiCall('GET', actions.GET_CURRENT_USER)
                .then(response => {
                    console.log('User data from external API:', response.data);
                    // External API response structure: { success: true, data: { ...user data... } }
                    if (response.data && response.data.success && response.data.data) {
                        const obj = {
                            user: response.data.data,
                            rootState
                        };
                        commit('GET_USER', obj);
                    } else {
                        // Fallback to local session endpoint
                        axiosGet(actions.LOGIN_USER).then(res => {
                            console.log('User data from local API (fallback):', res.data);
                            const userData = res.data?.data || res.data;
                            const obj = {
                                user: userData,
                                rootState
                            };
                            commit('GET_USER', obj);
                        }).catch(err => {
                            console.error('Error fetching user from fallback:', err);
                        });
                    }
                })
                .catch(error => {
                    console.warn('External API failed, trying local endpoint:', error);
                    // Fallback to local session endpoint
                    axiosGet(actions.LOGIN_USER).then(res => {
                        console.log('User data from local API:', res.data);
                        // Handle both response structures
                        const userData = res.data?.data || res.data;
                        const obj = {
                            user: userData,
                            rootState
                        };
                        commit('GET_USER', obj);
                    }).catch(err => {
                        console.error('Error fetching user:', err);
                    });
                });
        },
        addUser({commit, state}, user) {
            commit('SET_USERS', state.users.concat([user]));
        },
        getNotifications({commit, rootState}, nextPage = actions.NOTIFICATIONS) {
            let url = nextPage === actions.NOTIFICATIONS ? `${actions.NOTIFICATIONS}?per_page=5` : nextPage;
            
            // Add per_page to pagination URLs if not present
            if(nextPage !== actions.NOTIFICATIONS && !url.includes('per_page=')) {
                url += url.includes('?') ? '&per_page=5' : '?per_page=5';
            }
            
            externalApiCall('GET', url).then(({data}) => {
                let obj = {
                    notifications: data.data || [],
                    total_unread: 0,
                    rootState
                };
                
                // Fetch unread count independently
                externalApiCall('GET', '/api/notifications/unread-count').then((res) => {
                    obj.total_unread = res.data?.data?.unread_count || 0;
                    commit('GET_NOTIFICATIONS', obj);
                }).catch(() => {
                    commit('GET_NOTIFICATIONS', obj);
                });
            }).catch(err => console.warn('Error fetching notifications:', err));
        },
        getUsers({commit, state}, payload = {}) {
            const url = payload.users ? `${actions.GET_USERS}?existing=${payload.users}` : actions.GET_USERS;
            axiosGet(url).then(({data}) => {
                commit('SET_USERS', data)
            });
        },
    }
}
